// extracted by mini-css-extract-plugin
module.exports = {"Root":"MapFloatPanel_Root__13JD6"};